import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { NgLetModule } from 'ng-let';

import { ListModule } from '../components/list.module';
import { PageLayoutModule } from '../page-layout';

import { DevicesComponent } from './devices/devices.component';
import { settingsReducer } from './service/reducer';
import { SettingsService } from './service/settings.service';
import { SettingsComponent } from './settings/settings.component';
import { EULAComponent } from './eula.modal.component';
import { ContentModule } from '../content';
import { ModalLayoutModule } from '../modal-layout';
import { EULAPage } from './eula.page';
import { RelativeDatePipe } from '../relative-date';
import { AbsAccountSettingsComponent } from './account/account-settings.component';
import { RegistrationPage } from './registration/registration.page';
import { VerifyEmailPage } from './verify-email/verify-email.page';
import { ResetPasswordRequestPage } from './reset-password/reset-password-request.page';
import { ResetPasswordConfirmPage } from './reset-password/reset-password-confirm.page';
import { ReauthPromptComponent } from './reauth-prompt/reauth-prompt.component';
import { LinkedAccountsComponent } from './linked-accounts/linked-accounts.component';

const SETTINGS_COMPONENTS = [
    SettingsComponent,
    DevicesComponent,
    AbsAccountSettingsComponent,
    EULAPage,
    EULAComponent,
    RegistrationPage,
    VerifyEmailPage,
    ResetPasswordRequestPage,
    ResetPasswordConfirmPage,
    ReauthPromptComponent,
    LinkedAccountsComponent
];
@NgModule({
    declarations: [...SETTINGS_COMPONENTS],
    exports: [...SETTINGS_COMPONENTS],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        IonicModule,
        StoreModule.forFeature('settings', settingsReducer),
        ListModule,
        PageLayoutModule,
        TranslateModule,
        NgLetModule,
        ContentModule,
        ModalLayoutModule,
        RelativeDatePipe
    ],
    providers: [SettingsService]
})
export class SettingsModule {}
